module.exports = __webpack_public_path__ + "static/resources_02-560x320-7bdbf991290472440167fe67a11e13ce.jpg";